export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Staff.vue?vue&type=template&id=0a68fd7c"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Crews/Staff.vue?vue&type=template&id=0a68fd7c
// module id = 2524
// module chunks = 31